import { qualifyUrls } from "routing/Routes";
const AWSCloudTrailRoutes = {
  INTEGRATIONS: {
    AWSCloudTrail: {
      ACTIVITYAPI: {
        index: "/integrations/cloudtrail"
      }
    }
  }
};
const ApiRoutes = {
  INTEGRATIONS: {
    AWSCloudTrail: {
      SAVE_INPUT: "/plugins/org.graylog.integrations/cloudtrail/inputs?setup_wizard=true",
      CHECK_CREDENTIALS: "/plugins/org.graylog.integrations/cloudtrail/check_credentials",
      GET_AWS_REGIONS: "/plugins/org.graylog.integrations/cloudtrail/getawsregions"
    }
  }
};
const DocsRoutes = {
  INTEGRATIONS: {
    AWSCloudTrail: {
      GRAYLOG_AWSCloudTrail_ACTIVITY_LOG_INPUT: "integrations/inputs/graylog_AWSCloudTrail_ActivityLog_Input.html#graylog-AWSCloudTrail-activitylog-input"
    }
  }
};
export default {
  ...qualifyUrls(AWSCloudTrailRoutes),
  unqualified: AWSCloudTrailRoutes
};
export { DocsRoutes, ApiRoutes };
